export default function (a) {
  switch (a) {
    case 'RUR': {
      return '&#8381;'
    }
    case 'USD': {
      return '$'
    }
    case 'EUR': {
      return '&euro;'
    }
    case 'UAH': {
      return '&yen;'
    }
    default:
      return a
  }
}
